import React from 'react';

import { Button, ButtonProps } from '~/components/button';

export const HeaderTextButton: React.FC<Pick<ButtonProps, 'onPress' | 'label'>> = ({ label, onPress }) => {
    return <Button size="small" shape="rounded" onPress={onPress} label={label} />;
};
